/* Right-click a square that has no appointment on it: pick from the booked
 * services of that type still upcoming or in progress. */
import * as Vue from 'vue';
import { store } from '../store.js';

export const AttachAppointment = {
  name: 'AttachAppointment',
  setup: function () {
    var turn = Vue.computed(function () {
      if (!store.ui.attachPick) return null;
      return store.turnOf(store.ui.attachPick.turnId);
    });

    var staff = Vue.computed(function () {
      if (!turn.value) return null;
      return store.staffOf(turn.value.staffId);
    });

    // The square's colour, from the store — the same three lines lived in
    // this file, move-confirm and attach-appointment.
    var color = Vue.computed(function () {
      return store.colorOfTurn(turn.value);
    });

    var options = Vue.computed(function () {
      if (!turn.value) return [];
      return store.attachableAppointments(turn.value.serviceId);
    });

    // Same as the assign sheet: carry the booking's ids, not just its names,
    // so the link survives the appointment being edited. See attachToTurn.
    function choose(o) {
      store.attachToTurn(turn.value.id, {
        appointmentId: o.appt.id,
        appointmentServiceId: o.svc.id,
        sourceServiceId: o.svc.serviceId,
        clientId: o.appt.clientId,
        clientName: o.appt.clientName,
        sourceServiceName: o.svc.name
      });
      store.closeAttachPick();
    }

    return {
      turn: turn, staff: staff, color: color, options: options, choose: choose,
      auth: store.auth,
      formatClock: store.formatClock,
      close: store.closeAttachPick
    };
  },
  template: [
    '<div v-if="turn" class="modal-scrim" @click.self="close">',
    '  <div class="sheet sheet--wide" role="dialog" aria-modal="true">',
    '    <div class="sheet__head" :style="{ \'--svc\': color }">',
    '      <span class="sheet__letter">{{ turn.serviceLetter }}</span>',
    '      <div>',
    '        <h3>Attach an appointment</h3>',
    '        <p>{{ staff ? staff.name : turn.staffName }}&rsquo;s {{ turn.serviceName }}</p>',
    '      </div>',
    '    </div>',
    '',
    '    <div class="assign__section">',
    '      <p v-if="!auth.user" class="warn-line">',
    '        Sign in from the appointments pane to see today&rsquo;s book.</p>',
    '      <p v-else-if="!options.length" class="appt-empty">',
    '        No unassigned {{ turn.serviceName }} booked for the rest of today.</p>',
    '      <ul v-else class="pick-list">',
    '        <li v-for="o in options" :key="o.svc.id">',
    '          <button type="button" class="pick" @click="choose(o)">',
    '            <span class="pick__time">{{ formatClock(o.svc.startsAt) }}</span>',
    '            <span class="pick__main">',
    '              <span class="pick__client">{{ o.appt.clientName }}<client-note :client-id="o.appt.clientId" /></span>',
    '              <span class="pick__svc">{{ o.svc.name }}</span>',
    '            </span>',
    '            <span class="pick__tag" :class="o.upcoming ? \'is-later\' : \'is-live\'">',
    '              {{ o.upcoming ? "Upcoming" : "In progress" }}</span>',
    '          </button>',
    '        </li>',
    '      </ul>',
    '    </div>',
    '',
    '    <div class="sheet__actions">',
    '      <button type="button" class="btn btn--quiet" @click="close">Cancel</button>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join('\n')
};
